import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XIconButton, XImage, XText } from "IZOX/_X";
import HTMLReactParser from "html-react-parser";
import _ from "lodash";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class GInsure extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(GInsure.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toPage = (url) => {
    NavX.NewWindow(url);
  }

  renderCard(o, i){
    let {title, desc, pic, url} = o;
    return (
      <VStack round={20} m={5} key={i}
        style={{
          boxShadow: `1px 1px 2px 2px ${ColorX.CSS("greyOut", 0.2)}`,
          zIndex: 10
        }}
        bgColor={ColorX.CSS("pureWhite")}
        >
        <HStack height={243}>
          <XImage source={pic} width={302} height={243}/>
        </HStack>
        <HStack pV={16} pH={16} height={80} bgColor={ColorX.CSS("pureWhite")}>
          <VStack>
            <XText fontSize={16} fullWidth textAlign="|" bold 
              color={ColorX.CSS("Stone")}            
              style={{fontWeight: 900}}>
              {LocaleX.Parse(title)}
            </XText>
            <XText fullWidth textAlign="[" fontSize={14} style={{fontWeight: 400}}>
              {LocaleX.Parse(desc)}
            </XText>
          </VStack>
          <Spacer/>
          <XIconButton bgColor={ColorX.CSS("Grass")} padding={5} 
            onPress={() => GFunc.Download(url, LocaleX.Parse(title))}>
            <XImage source="/Images/home/rightarrow.png" width={20} height={20}/>
          </XIconButton>
        </HStack>
        
      </VStack>
    );
  }

  renderContent(){
    let {info} = this.props;
    let {desc} = info?.ginsurance ?? {};
    return (
      <VStack spacing={16} width={SysConfig.ContentWidth} HAlign="[" pH={80}>
        <VStack width={680}>
          <XText fullWidth textAlign="[" color={ColorX.CSS("Grass")} bold fontSize={32}>
            {LocaleX.Parse({
              EN: "General Insurance",
              TC: "一般保險"
            })}
          </XText>
          <XText fullWidth fontSize={16}>
            {HTMLReactParser(LocaleX.Parse(desc))}
          </XText>
        </VStack>
      </VStack>
    );
  }

  renderSlide(){
    let {info} = this.props;
    let {ginsurance} = info ?? {};
    let {cards} = ginsurance ?? {};
    return (
      <HStack spacing={20} width={SysConfig.ContentWidth} pH={16} HAlign="[">
        <HStack style={{flexGrow: 1}} spacing={24}>
          {_.map(cards, (o, i) => {
            return this.renderCard(o, i);
          })}
        </HStack>
      </HStack>
    );
  }

  renderCardM(o, i){
    let {title, desc, pic, url} = o;
    return (
      <VStack round={20} m={10} key={i} fullWidth 
        lockWidth={320} lockHeight={320}
        shadow shadowSize={2} style={{aspectRatio: 1}}
        bgColor={ColorX.CSS("pureWhite")}
        >
        <HStack>
          <XImage source={pic} fullWidth/>
        </HStack>
        <HStack pV={16} pH={16} height={80} bgColor={ColorX.CSS("pureWhite")}>
          <VStack>
            <XText fontSize={16} fullWidth textAlign="|" bold 
              color={ColorX.CSS("Stone")}            
              style={{fontWeight: 900}}>
              {LocaleX.Parse(title)}
            </XText>
            <XText fullWidth textAlign="[" fontSize={14} style={{fontWeight: 400}}>
              {LocaleX.Parse(desc)}
            </XText>
          </VStack>
          <Spacer/>
          <XIconButton bgColor={ColorX.CSS("Grass")} p={5} 
            onPress={() => GFunc.Download(url, LocaleX.Parse(title))}>
            <XImage source="/Images/home/rightarrow.png" width={30} height={30}/>
          </XIconButton>
        </HStack>
      </VStack>
    );
  }

  renderNormal(){
    return (
      <VStack fullWidth mB={80} pB={80}
        style={{
          background: ColorX.GetLinearGradient("grassGlowing", 180, 1)
        }}>
        {this.renderContent()}
        {this.renderSlide()}
      </VStack>
    );
  }

  renderSlideM(){
    let {info} = this.props;
    let {ginsurance} = info ?? {};
    let {cards} = ginsurance ?? {};
    return (
      <HStack fullWidth pH={36} HAlign="[">
        <HStack fullWidth p={2} flexWrap="wrap">
          {_.map(cards, (o, i) => {
            return this.renderCardM(o, i);
          })}
        </HStack>
      </HStack>
    );
  }

  renderContentM(){
    let {info} = this.props;
    let {desc} = info?.ginsurance ?? {};
    return (
      <VStack spacing={16} fullWidth pH={40}>
        <XText fullWidth textAlign="[" color={ColorX.CSS("Grass")} bold fontSize={32}>
          {LocaleX.Parse({
            EN: "General Insurance",
            TC: "一般保險"
          })}
        </XText>
        <XText fullWidth fontSize={16}>
          {HTMLReactParser(LocaleX.Parse(desc))}
        </XText>
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth mB={80} pB={80} spacing={30}
        style={{
          background: ColorX.GetLinearGradient("grassGlowing", 180, 1)
        }}>
        {this.renderContentM()}
        {this.renderSlideM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(GInsure);
